import React from "react";
import Helmet from "react-helmet";
import Jumbotron from "../components/Jumbotron";
import CallToAction from "../components/CallToAction";
import StatBar from "../components/StatBar";
import PageWrapper from "../components/PageWrapper";
import styles from "../styles/capabilities.module.scss";

import HighlightBanner from "../components/HighlightBanner";

const Capability = ({ data, transition, location }) => {
	const {
		page_title
	} = data.allMvruJson.edges[0].node.capability;

	const pageSettings = data.contentfulCapabilityPage;
	const stats = data.stats.edges;
	const cta = data.cta.edges[0].node;
	const capabilities = data.capability.edges;

	return (
		<PageWrapper locale={pageSettings.node_locale} location={location} data={data.layout.edges[0].node}>
			<main role="main" style={transition && transition.style}>
				<Helmet title={pageSettings.pageTitle  + " | Mahidol Vivax Research Unit"} />
				<Jumbotron
					type="jumbotron_b"
					bottomLine="true"
					className="mb-0"
					textAlign="text-center"
					contentAlign="justify-content-md-center"
				>
					<h1>{pageSettings.pageTitle}</h1>
				</Jumbotron>
	
				<div className="container my-lg-5">
					{capabilities.map(({node}, i) => {
						return (
							<div key={i + 1} className="mb-5">
								<HighlightBanner
									contentAlign={i % 2 > 0 ? "start" : "end"}
									image={node.featuredImage}
									title={node.title}
									description={node.leadingParagraph}
									details={node.subsections}
									gallery={node.gallery}
								/>
	
								{i === 0 && (
									<StatBar
										stats={[
											stats[0].node,
											stats[1].node,
											stats[2].node
										]}
									/>
								)}
								{i === 1 && (
									<StatBar
										stats={[
											stats[3].node,
											stats[4].node,
											stats[5].node
										]}
									/>
								)}
							</div>
						);
					})}
				</div>
	
				<div className="grey_bg">
					<CallToAction
						className="py-5"
						leadText={cta.leadingText}
						text={cta.content.childMarkdownRemark.html}
						buttonLabel={cta.buttonLabel}
						destination={`/${pageSettings.node_locale}${
							cta.linkTo
						}`}
						arrow={true}
					/>
				</div>
			</main>
		</PageWrapper>
	);
};

export default Capability;

export const query = graphql`
	query CapabilityPageQuery($id: String!, $locale: String!)  {

		layout: allMvruJson {
			edges {
				node {
					...layoutFields
				}
			}
		}

		contentfulCapabilityPage(id: { eq: $id }) {
			pageTitle
			metaDescription {
				metaDescription
			}
			node_locale
		}

		
		capability: allContentfulCapability(
			filter: { node_locale: { eq: $locale } }
			sort: {order: ASC fields: [order]}
		) {
			edges {
				node {
					order
					title
					leadingParagraph {
						content: childMarkdownRemark {
							html
						}
					}
					featuredImage {
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							sizes
						}
					}
					gallery {
						title
						sizes {
							base64
							aspectRatio
							src
							srcSet
							sizes
						}
					}
					subsections {
						title
						content {
							content: childMarkdownRemark {
								html
							}
						}
					}
				}
			}
		}

		stats: allContentfulStat(
			filter: { node_locale: { eq: $locale } }
			sort: { order: ASC, fields: [order] }
			limit: 6
		) {
			edges {
				node {
					title
					description {
						content: childMarkdownRemark {
							html
						}
					}
				}
			}
		}
		cta: allContentfulCallToAction(
			filter: {
				pageLocation: { eq: "capabilities" }
				node_locale: { eq: $locale }
			}
		) {
			edges {
				node {
					id
					pageLocation
					leadingText
					content {
						childMarkdownRemark {
							html
						}
					}
					linkTo
					buttonLabel
				}
			}
		}

		allMvruJson {
			edges {
				node {
					capability {
						page_title
						
					}
				}
			}
		}
	}
`;



// WEBPACK FOOTER //
// ./src/templates/capability-template.js